import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { COMPARE_HIERARCHIES } from '../constants/ActionsTypes'
import { compareHierarchies as compareHierarchiesAPI } from '../api/Hierarchies'
import { compareHierarchiesSuccess, compareHierarchiesError } from '../actions/Hierarchies'

function* compareHierarchiesRequest({ payload }) {
  try {
    const response = yield call(compareHierarchiesAPI, payload)
    yield put(compareHierarchiesSuccess(response))
  } catch (err) {
    yield put(compareHierarchiesError(err.message || 'Error comparing hierarchies'))
  }
}

export function* compareHierarchiesSaga() {
  yield takeEvery(COMPARE_HIERARCHIES, compareHierarchiesRequest)
}

export default function* rootSaga() {
  yield all([fork(compareHierarchiesSaga)])
}
